export default __webpack_public_path__ + "static/media/TERRAZA.17f0b537.jpg";